import React, { useEffect, useState } from "react";
import download from "../../assets/clarity_download-line.png";
import eye from "../../assets/eye.png";
import doc from "../../assets/lsicon_report-outline.png";
import close from "../../assets/closeIcon.png";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SelectButton from "../../components/SelectButton";
import { useSelector } from "react-redux";
import ManagerSelect from "../../components/Registration-details/ManagerSelect";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

const toastIds = {
  approveSuccess: "investor-approve-success-toast",
  approveError: "investor-approve-error-toast",
  querySuccess: "investor-query-success-toast",
  queryError: "investor-query-error-toast",
  rejectSuccess: "investor-reject-success-toast",
  rejectError: "investor-reject-error-toast",
};

function RegistrationDetails() {
  const navigate = useNavigate();
  const [investorDetails, setInvestorDetails] = useState([]);
  const location = useLocation();
  const id = location?.state?.uniqueId;
  const [approvePopupVisible, setApprovePopupVisible] = useState(false);
  const [rejectPopupVisible, setRejectPopupVisible] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const { userPermissionData } = useSelector((state) => state.userPermission);

  const [reason, setReason] = useState("");
  const [remarks, setRemarks] = useState("");
  const [characterCount, setCharacterCount] = useState(0);
  const [remarksError, setRemarksError] = useState("");
  console.log("id-details", investorDetails);

  const [selectedOption, setSelectedOption] = useState("");

  const [queryRemark, setQueryRemark] = useState({
    email: "",
    idVerification: "",
    bank: "",
    demat: "",
    personal: "",
    signature: "",
    photo: "",
  });

  console.log("queryRemark", queryRemark);

  // Approve Handlers
  const handleApproveClick = (message) => {
    setPopupMessage(message);
    setApprovePopupVisible(true);
  };

  const closeApprovePopup = () => {
    setApprovePopupVisible(false);
    setPopupMessage("");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setQueryRemark((prevQueryRemark) => ({
      ...prevQueryRemark,
      [name]: value,
    }));
  };

  // Reject Handlers
  const handleRejectClick = () => {
    setRejectPopupVisible(true);
  };

  const closeRejectPopup = () => {
    setRejectPopupVisible(false);
    setReason("");
    setRemarks("");
    setRemarksError("");
    setCharacterCount(0);
  };

  const approveInvestor = async (updatedStatus) => {
    const endpoint = `${base_url}/${api_type}/investor/${id}/statusUpdate`;
    const payload = {
      status: updatedStatus,
      ...(updatedStatus === "query" && {
        // reason: reason, // Include only if rejected
        remarks: queryRemark,
      }),
    };

    try {
      const response = await axios.post(endpoint, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });

      const toastId =
        updatedStatus === "approve"
          ? toastIds.approveSuccess
          : toastIds.querySuccess;
      if (!toast.isActive(toastId)) {
        toast.success(
          response?.data?.message || "Status updated successfully!dd",
          {
            toastId: toastId,
            onClose: () => navigate("/registration/investor"),
            autoClose: 3000,
          }
        );
      }
    } catch (err) {
      console.error("Failed to update status:", err);
      setError(err.message);
      const toastId =
        updatedStatus === "approve"
          ? toastIds.approveError
          : toastIds.queryError;
      if (!toast.isActive(toastId)) {
        toast.error(
          err?.response?.data?.message ||
            "Failed to update investor status. Please try again.",
          {
            toastId: toastId,
            autoClose: 3000,
            onClose: () => navigate("/registration/investor"),
          }
        );
      }
    }
  };

  const handleApproveSubmit = () => {
    approveInvestor("approve");
    closeApprovePopup();
  };

  const handleReasonChange = (value) => setReason(value);

  const handleRemarksChange = (e) => {
    setRemarks(e.target.value);
    setCharacterCount(e.target.value.length);
  };

  const handleSubmit = () => {
    const isAnyFieldFilled = Object.values(queryRemark).some(
      (value) => value.trim() !== ""
    );

    if (!isAnyFieldFilled) {
      toast.error("Please fill at least one field before submitting.");
      return;
    }

    // if (!remarks.trim()) {
    //   setRemarksError("Please enter remarks for query update");
    //   return;
    // }

    setRemarksError("");
    console.log("Reason:", reason);
    console.log("Remarks:", remarks);
    approveInvestor("query");
    closeRejectPopup();
  };
  console.log(location);

  const [error, setError] = useState(null);
  const options = ["Incorrect Details", "Incorrect Demat Details"];

  const fetchInvestorDetails = async () => {
    const endpoint = `${base_url}/${api_type}/investor/${id}`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });
      if (response?.data?.data?.investorDetails?.remarksData) {
        setQueryRemark(response?.data?.data?.investorDetails?.remarksData);
      }
      setInvestorDetails(response?.data?.data?.investorDetails);
    } catch (err) {
      setError(err.message);
    }
  };
  useEffect(() => {
    fetchInvestorDetails();
  }, []);

  const downloadRegistorDetails = async () => {
    const endpoint = `${base_url}/${api_type}/investor/export-to-excel/${id}`;
    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
        responseType: "blob",
      });

      // Create a blob from the response data
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a temporary link to trigger the download
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "investor_details.xlsx"; // Provide a default file name

      // Append the link to the document and trigger the click
      document.body.appendChild(link);
      link.click();

      // Clean up the link and blob URL
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      console.log("File downloaded successfully!");
      console.log(response, "response-download");
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  const onDownloadClick = () => {
    downloadRegistorDetails();
  };

  const rejectPartner = async (updatedStatus) => {
    const endpoint = `${base_url}/${api_type}/investor/${id}/statusUpdate`;
    const payload = {
      status: "rejected",
      // ...(updatedStatus === "rejected" && {
      //   reason: reason, // Include only if rejected
      //   remarks: remarks,
      // }),
    };

    try {
      const response = await axios.post(endpoint, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });
      //   setInvestorDetails(response?.data?.data?.investorDetails);

      if (!toast.isActive(toastIds.rejectSuccess)) {
        // toast.success(response?.data?.message || "Rejected successfully!",
        toast.success("Rejected successfully!", {
          toastId: toastIds.rejectSuccess,
          onClose: () => navigate("/registration/investor"),
          autoClose: 3000,
        });
      }
    } catch (err) {
      setError(err.message);
      if (!toast.isActive(toastIds.rejectError)) {
        toast.error(
          err?.response?.data?.message ||
            "Failed to update investor status. Please try again.",
          {
            toastId: toastIds.rejectError,
            autoClose: 3000,
            onClose: () => navigate("/registration/investor"),
          }
        );
      }
      console.error("Failed to update status:", err);
    }
  };
  const handleReject = () => {
    if (!remarks.trim()) {
      setRemarksError("Please enter remarks for rejection");
      return;
    }

    setRemarksError("");
    rejectPartner();
    closeRejectPopup();
  };
  const incomeRanges = {
    LT1L: "₹ 1,00,000",
    GT1L_to_LT5L: "₹ 1,00,000 - ₹ 5,00,000",
    GT5L_to_LT10L: "₹ 5,00,000 - ₹ 10,00,000",
    GT10L_to_LT25L: "₹ 10,00,000 - ₹ 25,00,000",
    GT25L_to_LT1CR: "₹ 25,00,000 - ₹ 1,00,00,000",
    GT1CR: "₹ 1,00,00,000 and above",
  };

  const handleOpenImage = (url) => {
    if (url) {
      window.open(url, "_blank");
    } else {
      toast.error("No document found");
    }
  };

  const formatISOToDate = (isoDate) => {
    if (!isoDate) return ""; // Handle empty case
    return new Date(isoDate).toISOString().split("T")[0]; // Extract yyyy-mm-dd
  };

  console.log("details", investorDetails);
  return (
    <div className=" mt-20 ml-4 rounded-[20px] bg-white">
      <div className="border-2 rounded-[20px]">
        <div className="flex flex-wrap justify-between items-center px-4 py-4 border-b-2">
          <h1 className="text-[#0C141C] text-[20px] font-bold">
            Personal Details
          </h1>
          {userPermissionData?.registration?.download && (
            <div
              onClick={onDownloadClick}
              class="flex items-center bg-[#035C98] px-4 rounded-[8px]"
            >
              <button class="btn   text-white font-bold  ">Download</button>
              <img src={download} alt="download" />
            </div>
          )}
        </div>
        <div className="w-full flex flex-wrap gap-x-16 mt-2 py-2">
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">UCC Code</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.uccCode || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Name</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.name || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Mother Name</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1 capitalize">
              {investorDetails?.motherName || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Father Name</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1 capitalize">
              {investorDetails?.fatherName || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Gender </label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1 capitalize">
              {investorDetails?.gender || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Date of Birth {`(YYYY-MM-DD)`}</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {formatISOToDate(investorDetails?.dob) || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Phone No.</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.mobileNumber || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Email Id</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.email || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">PAN</label>
            <p className="bg-[#F5F7F9] px-3 py-4 mt-1">
              {investorDetails?.panCardNumber}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Aadhar Number</label>
            <p className="bg-[#F5F7F9] px-3 py-4 mt-1">
              {investorDetails?.aadharCardNumber}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Address</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1 text-wrap break-words">
              {investorDetails?.address || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Pin Code</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.zipcode || "xxxx"}
            </p>
          </div>
        </div>
      </div>
      <div className="border-2 rounded-[20px] mt-5">
        <div className="flex flex-wrap justify-between items-center px-4 py-4 border-b-2">
          <h1 className="text-[#0C141C] text-[20px] font-bold">
            Aditional Details
          </h1>
        </div>
        <div className="w-full flex flex-wrap gap-x-16 mt-2 py-2">
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Occupation</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1 capitalize">
              {investorDetails?.occupation || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Are You Politically Exposed ?</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1 capitalize">
              {investorDetails?.politicallyExposedPerson || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Martial Status</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1 capitalize">
              {investorDetails?.maritalStatus || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Residentails Status</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1 capitalize">
              {investorDetails?.residentialStatus || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Annual Income Range </label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {incomeRanges[investorDetails?.annualIncome] || "xxxx"}
            </p>
          </div>
        </div>
      </div>
      <div className="border-2 rounded-[20px] mt-5">
        <div className="flex flex-wrap justify-between items-center px-4 py-4 border-b-2">
          <h1 className="text-[#0C141C] text-[20px] font-bold">Bank Details</h1>
        </div>
        <div className="w-full flex flex-wrap gap-x-16 mt-2 py-2">
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Account Name</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.accountName || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Account Number</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.accountNumber || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">IFSC</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.ifscCode || "xxxx"}
            </p>
          </div>
        </div>
      </div>
      <div className="border-2 rounded-[20px] mt-5">
        <div className="flex flex-wrap justify-between items-center px-4 py-4 border-b-2">
          <h1 className="text-[#0C141C] text-[20px] font-bold">
            Demat Details
          </h1>
        </div>
        <div className="w-full flex flex-wrap gap-x-16 mt-2 py-2">
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Demat A/c No. (BO ID)</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1">
              {investorDetails?.dematAccountNumber || "xxxx"}
            </p>
          </div>

          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">CML Document </label>
            <div className="bg-[#F5F7F9] px-3 py-2 mt-1 flex justify-between items-center">
              <div className="flex items-center flex-1 min-w-0">
                <img src={doc} alt="doc" className="pr-2 flex-shrink-0" />
                <p
                  className="truncate"
                  title={investorDetails?.cmlReportUrl || "xxxx"}
                >
                  {investorDetails?.cmlReportUrl || "xxxx"}
                </p>
              </div>
              <img
                src={eye}
                alt="eye"
                className="cursor-pointer ml-2 flex-shrink-0"
                onClick={() => handleOpenImage(investorDetails?.cmlReportUrl)}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="border-2 rounded-[20px] mt-5">
        <div className="flex flex-wrap justify-between items-center px-4 py-4 border-b-2">
          <h1 className="text-[#0C141C] text-[20px] font-bold">
            Manager Details
          </h1>
        </div>
        <div className="w-full flex flex-wrap gap-x-16 mt-2 py-2">
          <div className="px-4 py-2 md:w-1/3">
            <label className=" py-2">Select Manager </label>
            {/* <p className="bg-[#F5F7F9] px-3 py-2 mt-1 capitalize">
              {investorDetails?.settlementPeriod || "xxxx"}
            </p> */}
            <ManagerSelect userType="investor" userId={investorDetails?.id} />
          </div>
        </div>
      </div>
      <div className="border-2 rounded-[20px] mt-5">
        <div className="flex flex-wrap justify-between items-center px-4 py-4 border-b-2">
          <h1 className="text-[#0C141C] text-[20px] font-bold">
            Other Details
          </h1>
        </div>
        <div className="w-full flex flex-wrap gap-x-16 mt-2 py-2">
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Settlement Period</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1 capitalize">
              {investorDetails?.settlementPeriod || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Statement Period</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1 capitalize">
              {investorDetails?.statementPeriod || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Share Email With RTA</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1 capitalize">
              {investorDetails?.shareEmailWithRta || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Annual Report Type</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1 capitalize">
              {investorDetails?.annualReportType || "xxxx"}
            </p>
          </div>
          <div className="px-4 py-2 md:w-[358px]">
            <label className=" py-2">Holding Statement Mail Period</label>
            <p className="bg-[#F5F7F9] px-3 py-2 mt-1 capitalize">
              {investorDetails?.holdingStatementMailPeriod || "xxxx"}
            </p>
          </div>
        </div>
      </div>

      <div className="border-2 rounded-[20px] mt-5">
        <div className="flex flex-wrap justify-between items-center px-4 py-4 border-b-2">
          <h1 className="text-[#0C141C] text-[20px] font-bold">
            Uploaded Document
          </h1>
        </div>

        <div className="w-full flex flex-wrap gap-x-16 mt-2 py-2">
          <div className="px-4 md:w-[25%] py-2 ">
            {/* <label className=" py-2">Aadhar Card</label> */}
            <div className="bg-[#F5F7F9] w-full px-3 py-2 mt-1 flex justify-between">
              <div className="flex w-full">
                <img src={doc} alt="doc" className="pr-2" />
                {/* <p>{investorDetails?.aadharCardDoc || "xxxx"}</p> */}
                <p className="">{"Aadhar Card"} </p>
              </div>
              <img
                src={eye}
                className="cursor-pointer"
                alt="eye"
                onClick={() => handleOpenImage(investorDetails?.aadharCardDoc)}
              />
            </div>
          </div>

          <div className="px-4 py-2 md:w-[25%]">
            {/* <label className=" py-2">Pan Card</label> */}
            <div className="bg-[#F5F7F9] px-3 py-2 mt-1 flex justify-between">
              <div className="flex w-full">
                <img src={doc} alt="doc" className="pr-2" />
                {/* <p>{investorDetails?.panCardDoc || "xxxx"} </p> */}
                <p>{"Pan Card"} </p>
              </div>
              <img
                src={eye}
                className="cursor-pointer"
                alt="eye"
                onClick={() => handleOpenImage(investorDetails?.panCardDoc)}
              />
            </div>
          </div>

          <div className="px-4 py-2 md:w-[30%]">
            {/* <label className=" py-2">Account Opening Form</label> */}
            <div className="bg-[#F5F7F9] px-3 py-2 mt-1 flex justify-between">
              <div className="flex w-full">
                <img src={doc} alt="doc" className="pr-2" />
                {/* <p>{investorDetails?.accountOpeningForm || "xxxx"} </p> */}
                <p>{"Account Opening Form"} </p>
              </div>
              <img
                src={eye}
                className="cursor-pointer"
                alt="eye"
                onClick={() =>
                  handleOpenImage(investorDetails?.accountOpeningForm)
                }
              />
            </div>
          </div>

          <div className="px-4 py-2 md:w-[25%]">
            {/* <label className=" py-2">Bank Cheque</label> */}
            <div className="bg-[#F5F7F9] px-3 py-2 mt-1 flex justify-between">
              <div className="flex w-full">
                <img src={doc} alt="doc" className="pr-2" />
                {/* <p>{investorDetails?.chequeDoc || "xxxx"} </p> */}
                <p>{"Bank Cheque"} </p>
              </div>
              <img
                src={eye}
                className="cursor-pointer"
                alt="eye"
                onClick={() => handleOpenImage(investorDetails?.chequeDoc)}
              />
            </div>
          </div>

          <div className="px-4 py-2 md:w-[25%]">
            {/* <label className=" py-2">Photo</label> */}
            <div className="bg-[#F5F7F9] px-3 py-2 mt-1 flex justify-between">
              <div className="flex w-full">
                <img src={doc} alt="doc" className="pr-2" />
                {/* <p>{investorDetails?.accountOpeningForm || "xxxx"} </p> */}
                <p>{"Photo"} </p>
              </div>
              <img
                onClick={() => handleOpenImage(investorDetails?.selfie)}
                src={eye}
                alt="eye"
                className="cursor-pointer"
              />
            </div>
          </div>
          <div className="px-4 py-2 md:w-[25%]">
            {/* <label className=" py-2">Photo</label> */}
            <div className="bg-[#F5F7F9] px-3 py-2 mt-1 flex justify-between">
              <div className="flex w-full">
                <img src={doc} alt="doc" className="pr-2" />
                {/* <p>{investorDetails?.accountOpeningForm || "xxxx"} </p> */}
                <p>{"Signature"} </p>
              </div>
              <img
                onClick={() => handleOpenImage(investorDetails?.signature)}
                src={eye}
                alt="eye"
                className="cursor-pointer"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-between items-center pt-10 pb-10">
        <div
          onClick={() => navigate("/registration/investor")}
          className="w-[150px] rounded-[8px] border-2 ml-4 py-2 px-6 flex justify-center cursor-pointer"
        >
          Back
        </div>
        {investorDetails?.kycStatus !== "approve" && (
          <div className="flex mr-4">
            {investorDetails?.kycStatus !== "pending" && (
              <>
                {userPermissionData?.registration?.approval && (
                  <div
                    onClick={handleRejectClick}
                    className="mr-4 min-w-[150px] cursor-pointer text-[#035C98] rounded-[8px] border-2 py-2 px-6 flex justify-center"
                  >
                    Reject / Submit Query
                  </div>
                )}
              </>
            )}
            {userPermissionData?.registration?.approval && (
              <div
                onClick={() =>
                  handleApproveClick("Are you sure you want to approve?")
                }
                className="min-w-[150px] cursor-pointer bg-[#035C98] text-white rounded-[8px] border-2 py-2 px-6 flex justify-center"
              >
                Approve
              </div>
            )}
          </div>
        )}

        {approvePopupVisible && (
          <div className=" fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 w-[400px] text-center">
              <div className="flex justify-between">
                <p className="mb-4 font-bold">{popupMessage}</p>
                <img
                  src={close}
                  alt="close"
                  className="w-4 h-4"
                  onClick={closeApprovePopup}
                />
              </div>
              <div className="flex justify-end gap-x-2">
                <button
                  className=" text-[#313131] rounded-md py-2 px-4 border-2"
                  onClick={closeApprovePopup}
                >
                  Cancel
                </button>
                <button
                  className="bg-[#429A3A] text-white rounded-md py-2 px-4"
                  onClick={() => {
                    console.log("Action confirmed");
                    handleApproveSubmit();
                    //   closeApprovePopup();
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}

        {rejectPopupVisible && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 w-[50%] relative">
              {/* Close Button */}

              {/* Title */}
              <div className="flex justify-between items-center">
                <h2 className="text-lg font-bold ">
                  Are you sure, you want to return to Investor?
                </h2>
                <img
                  src={close}
                  alt="close"
                  className="w-5 h-5 mt-[5px] cursor-pointer"
                  onClick={closeRejectPopup}
                />
              </div>

              {/* Form */}
              {/* <div className="mb-4">
              <label className="block font-medium mb-2">Select Reason</label>
              <SelectButton
                
                options={options}
                selectedValue={reason}
                onSelect={handleReasonChange}
              />
            </div> */}

              {/*  */}
              <div className="w-full flex flex-col justify-between items-start">
                {[
                  { name: "email", Title: "Email", state: "" },
                  {
                    name: "idVerification",
                    Title: "ID Verification",
                    state: "",
                  },
                  { name: "bank", Title: "Bank", state: "" },
                  { name: "demat", Title: "Demat", state: "" },
                  { name: "personal", Title: "Additional Details", state: "" },
                  // { name: "nominee", Title: "Nominee", state: "" },
                  { name: "signature", Title: "Signature", state: "" },
                  { name: "photo", Title: "Photo", state: "" },
                ].map((options, key) => (
                  <div className="w-full flex  items-center  gap-5 mt-5">
                    <input
                      className="border p-2 w-[30%]"
                      disabled
                      value={options?.Title}
                    />
                    <input
                      className="border p-2 w-[60%]"
                      placeholder="remarks"
                      name={options?.name}
                      value={queryRemark[options?.name]}
                      onChange={handleInputChange}
                    />
                  </div>
                ))}
              </div>

              {/*  */}

              {/* <div className="mb-4">
                <label className="block font-medium mb-2">
                  Remarks (If any)
                </label>
                <textarea
                  value={remarks}
                  onChange={handleRemarksChange}
                  maxLength={500}
                  placeholder="Remark"
                  className={`w-full border rounded-md px-3 py-2 h-20 ${
                    remarksError ? "border-red-500" : ""
                  }`}
                />
                {remarksError && (
                  <p className="text-red-500 text-sm mt-1">{remarksError}</p>
                )}
                <div className="text-right text-sm text-gray-500">
                  {characterCount}/500
                </div>
              </div> */}

              <div className="flex justify-between space-x-2 mt-4">
                <div>
                  <button
                    className="border bg-red-500 border-gray-300 text-white px-4 py-2 rounded-md hover:bg-gray-100"
                    onClick={handleReject}
                  >
                    Reject
                  </button>
                </div>
                <div className="space-x-2">
                  <button
                    className="border border-gray-300 text-gray-600 px-4 py-2 rounded-md hover:bg-gray-100"
                    onClick={closeRejectPopup}
                  >
                    Cancel
                  </button>
                  <button
                    className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                    onClick={handleSubmit}
                  >
                    Query
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default RegistrationDetails;
